<!-- <app-nav-bar></app-nav-bar> -->
<div class="card-wrapper">
  @if (order()) {
    <mat-card>
      <mat-card-header>
        <mat-card-title>Betaalstatus</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        @if (order()!.status === 'open' || order()!.status === 'pending') {
          <div>
            Je bent juist door het betalingssysteem gelopen en de betaling wordt nu verwerkt. Wanneer dit gebeurd is
            worden jouw credits en betalingsplan in jouw profiel zichtbaar.
          </div>
        }
        @if (order()!.status === 'paid') {
          <div>Gelukt, jouw betaling is ontvangen en wordt door ons verwerkt.</div>
        }
        @if (order()!.status === 'expired' || order()!.status === 'cancelled') {
          <div>Helaas.. Er is iets mis gegaan tijdens jouw betaling.</div>
        }
      </mat-card-content>
      <mat-card-footer>
        @if (order()!.status === 'open' || order()!.status === 'pending' || order()!.status === 'paid') {
          <button (click)="navigate('profile')" mat-flat-button>Doorgaan</button>
        }
        @if (order()!.status === 'expired' || order()!.status === 'cancelled') {
          <button (click)="navigate('pay')" mat-flat-button>Opnieuw proberen</button>
        }
      </mat-card-footer>
    </mat-card>
  }
</div>
